import { Input, StrictInputProps } from 'semantic-ui-react'
import styled from 'styled-components'

export default styled(Input)<StrictInputProps>`
  &&& {
    height: 30px;
  }
`
